import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { useLocalizedSentenceDict } from "../../hooks/useSentenceDict";

function Login({ onSubmit }) {
  const dict = useLocalizedSentenceDict();
  const { register, handleSubmit } = useForm();

  return (
    <>
      <p className="typo-body mb-[25px]">
        {dict.get("Login for faster checkout, order updates, and more!")}
      </p>

      <form onSubmit={handleSubmit(onSubmit)} id="login-form">
        <input
          placeholder={dict.get("Email")}
          type="email"
          className="w-full border border-black rounded-[4px] px-[15px] py-[10px] appearance-none typo-body"
          required
          {...register("email")}
        />
      </form>
    </>
  );
}

Login.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default withALErrorBoundary({
  name: "Login",
  priority: "P1",
})(Login);
